import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  TestWorkoutSolverPage,
  DaySetsPipe,
  EvaluateWorkoutPipe,
  DayExercisesPipe,
  EvaluateExercisePipe,
  EvaluateDayPipe,
} from 'pages/test-workout-solver/test-workout-solver';
import { ComponentsModule } from 'components/components.module';
import { PagesModule } from 'pages/pages.module';

@NgModule({
    declarations: [TestWorkoutSolverPage, DaySetsPipe, DayExercisesPipe, EvaluateWorkoutPipe, EvaluateExercisePipe, EvaluateDayPipe],
    imports: [CommonModule, PagesModule, ComponentsModule]
})
export class TestWorkoutSolverPageModule {}
